import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { AuthorizationInfoService } from '../services/authorization-info.service';
import { NotificationService } from '../services/notification.service';
import { UserService } from '../services/user.service';
import { getOrderIdFromRouteRecursive } from '../utils/ResolverUtil';
import { lastValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OrderReadAccessGuard {
    constructor(
        private userService: UserService,
        private authorizationService: AuthorizationInfoService,
        private notificationService: NotificationService
    ) {}

    public async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
        const orderId = getOrderIdFromRouteRecursive(route);
        if (orderId <= 0) {
            return false;
        }

        if (await this.userService.isLoggedIn()) {
            const info = await lastValueFrom(this.authorizationService.getAuthorizationInfo(orderId));
            if (!info.canRead) {
                this.notificationService.errorTranslate('COMMON.NOTALLOWED');
            }
            return info.canRead;
        } else {
            return false;
        }
    }
}
